import type {SVGProps} from 'react';

import Icon from './Icon';

const CloseIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <Icon width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
            <path
                d='M18 6L6 18M6 6L18 18'
                className='stroke-primary dark:stroke-secondary'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </Icon>
    );
};

export default CloseIcon;
